import { render, staticRenderFns } from "./DiagnosisStartText.vue?vue&type=template&id=0085f426&scoped=true"
import script from "./DiagnosisStartText.vue?vue&type=script&lang=js"
export * from "./DiagnosisStartText.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisStartText.vue?vue&type=style&index=0&id=0085f426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085f426",
  null
  
)

export default component.exports